export default __webpack_public_path__ + "static/google-play-badge-959422b93666d244f55ba67c303817cb.png";